// QA-560 — [취미는 아이돌](IDOL_HOBBY, catalog #106 확정 — catalog v1.0.67).
export const EVER_TV_CATEGORIES = ['CONCERT', 'MD', 'ARTIST', 'INTERVIEW', 'IDOL_HOBBY'] as const;

export type EverTvCategory = (typeof EVER_TV_CATEGORIES)[number];

export interface EverTvVideo {
  videoId: string;
  title: string;
  content: string;
  thumbnailUrl: string;
  artistName: string | null;
  duration: string | null;
  publishedAt: string | null;
  youtubeId: string | null;
  category: EverTvCategory | null;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface EverTvVideoPayload {
  videoId: string;
  title: string;
  content: string;
  thumbnailUrl: string;
  artistName?: string;
  duration?: string;
  publishedAt?: string;
  youtubeId?: string;
  category?: EverTvCategory;
  sortOrder: number;
  isActive: boolean;
}

